module.exports = __webpack_public_path__ + "img/드루이드.2457a7e8.png";